import './icon.less'
import SvgAttributeTag from '../../../../../../assets/inlineSvg/icon-tag.svg'
import SvgCustomAttributeTag from '../../../../../../assets/inlineSvg/icon-custom-attribute-tag.svg'
import SvgDetection from '../../../../../../assets/inlineSvg/icon-detection.svg'
import FilesSvg from '../../../../../../assets/inlineSvg/files-icon.svg'
import { Gear } from 'phosphor-react'
import React from 'react'

export const AttributeManagementSettingsIcon = () => {
  return (
    <div className="attr-colored-icon attribute-management-settings-icon">
      <Gear />
    </div>
  )
}

export const CustomAttributeTagIcon = () => {
  return (
    <div className="attr-colored-icon custom-attribute-tag-icon">
      <SvgAttributeTag />
    </div>
  )
}

export const CreateCustomAttributeTagIcon = () => {
  return (
    <div className="attr-colored-icon create-custom-attribute-tag-icon">
      <SvgCustomAttributeTag />
    </div>
  )
}

export const BasicDetailsIcon = () => {
  return (
    <div className="attr-colored-icon basic-details-icon">
      <FilesSvg />
    </div>
  )
}

export const DetectionIcon = () => {
  return (
    <div className="attr-colored-icon detection-icon">
      <SvgDetection />
    </div>
  )
}
